var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('jodit-editor',{ref:"joditEditor",attrs:{"value":_vm.content,"config":_vm.editorConfig},on:{"input":_vm.handleInput,"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }